import { Link } from 'react-router-dom';
import GlobalContext from '../context/GlobalProvider';
import ThemeContext from '../context/ThemeContext';
import { Menu, MenuItem, IconButton, Box, Divider, TextField, Collapse, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import { useContext, useEffect, useMemo, useState, useRef } from 'react';
import instance from '../axios/axios';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import useAuth from '../hooks/useAuth';
import logo from '../assets/medigaplogotransparent2.svg';
import StarIcon from './StarIcon';
import { favoriteReport, unfavoriteReport, getFavoriteReports } from '../services/favoritesService';

const linkStyle = {
    boxSizing: 'border-box',
    color: 'white',
    display: 'block',
    fontFamily: 'Overpass Mono',
    fontWeight: '400',
    padding: '.01px 20px',
    textDecoration: 'none',
    width: '100%',
}

const adminLinkStyle = {
    color: 'white',
    fontFamily: 'Shadows Into Light',
    fontSize: '1.5rem',
    fontWeight: '400',
    fontStyle: 'normal',
    textDecoration: 'none',
    marginLeft: '20px',
    marginRight: '20px',
}

const lightAdminLinkStyle = {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Shadows Into Light',
    fontSize: '1.5rem',
    fontStyle: 'normal',
    textDecoration: 'none',
    marginLeft: '20px',
    marginRight: '20px',
}

const lightLinkStyle = {
    boxSizing: 'border-box',
    color: 'black',
    display: 'block',
    fontFamily: 'Overpass Mono',
    fontWeight: '400',
    padding: '.01px 20px',
    textDecoration: 'none',
    width: '100%',
}

const menuSlotProps = {
    paper: {
        style: {
            width: '25%', // Increased width to accommodate hierarchical structure
            // NOTE: change here when wanting to adjust the size of the dropdown menu
        }
    }
}

const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}

const menuStyle = {
    marginTop: '2vh',  // Adjust the distance between the menu and the button
}

const logoutStyle = {
    paddingRight: "5vw",  // Add padding for spacing from the right edge
    minWidth: "auto",
    width: "fit-content",
    padding: "8px 16px",
    whiteSpace: 'nowrap',
}

const linkContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const divStyle = {
    display: 'flex',
    justifyContent: 'space-between',  // Adjusts the layout to create space between elements
    alignItems: 'center',
    paddingTop: "2vh",
    paddingLeft: "5vw",
    paddingRight: "5vw"
}

const logoStyle = {
    height: "13vh",
    width: "auto",
}


function Nav() {
    const { auth, setAuth } = useAuth();
    const { navItems, setNavItems, hierarchicalReports, setHierarchicalReports,
        setAnchorElReports, setAnchorElApps,
        anchorElApps, anchorElReports, apps, setApps,
        dashboards, setDashboards, refreshNavigation } = useContext(GlobalContext);
    const { isDarkTheme, toggleTheme } = useContext(ThemeContext);
    const [expandedReports, setExpandedReports] = useState(new Set());
    const [allExpanded, setAllExpanded] = useState(false);
    const [favoriteReports, setFavoriteReports] = useState(new Set());
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);
    const scrollTimeoutRef = useRef(null);


    //await instance.get('/users/access_list_from_jwt', { withCredentials: true })
    //    .then((response) => {
    //        if (response.status === 200) {
    //            console.log('fetched reports')
    //            const accessList = response.data.data.access;
    //            setNavItems(accessList);
    //            console.log(navItems);
    //        } else {
    //            console.log('Error getting access list');
    //        }
    //    })
    //    .catch((error) => {
    //        console.log('Error getting access list', error);
    //    });

    //await instance.get('/users/apps/access_list_from_jwt', { withCredentials: true })
    //    .then((response) => {
    //        if (response.status === 200) {
    //            console.log('fetched apps')
    //            const accessList = response.data.data.access;
    //            setApps(accessList);
    //        } else {
    //            console.log('Error getting access list');
    //        }
    //    })
    //    .catch((error) => {
    //        console.log('Error getting access list', error);
    //    });

    //await instance.get('/users/dashboards/access_list_from_jwt', { withCredentials: true })
    //    .then((response) => {
    //        if (response.status === 200) {
    //            console.log(`${response.data.data.access}`);
    //            setDashboards(response.data.data.access);
    //        } else {
    //            console.log("Error getting dashboards");
    //        }
    //    })
    //    .catch((error) => {
    //        console.log(`Error getting access list: ${error}`);
    //    });


    useEffect(() => {
        refreshNavigation();
        loadFavorites();
        const interval = setInterval(refreshNavigation, 30000);
        return () => clearInterval(interval);
    }, []);


    const loadFavorites = async () => {
        try {
            const response = await getFavoriteReports();
            if (response.status === 200) {
                const favoriteIds = new Set(response.data.data.favorites.map(fav => fav.report_id));
                setFavoriteReports(favoriteIds);
                setFavoritesLoaded(true);
            }
        } catch (error) {
            console.error('Error loading favorites:', error);
            setFavoritesLoaded(true); // Still set as loaded to prevent infinite loading
        }
    };

    const handleToggleFavorite = async (reportId, shouldFavorite) => {
        try {
            if (shouldFavorite) {
                await favoriteReport(reportId);
                setFavoriteReports(prev => new Set([...prev, reportId]));
            } else {
                await unfavoriteReport(reportId);
                setFavoriteReports(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(reportId);
                    return newSet;
                });
            }
        } catch (error) {
            console.error('Error toggling favorite:', error);
            throw error; // Re-throw to trigger animation reversal
        }
    };

    const openReports = Boolean(anchorElReports);
    const openApps = Boolean(anchorElApps);

    // Handle scroll detection for tooltip control
    useEffect(() => {
        if (!openReports) return;

        const handleScroll = (event) => {
            setIsScrolling(true);

            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }

            scrollTimeoutRef.current = setTimeout(() => {
                setIsScrolling(false);
            }, 200);
        };

        // Only use wheel events on the menu element
        const addScrollListeners = () => {
            const menuElement = document.getElementById('reports-menu');
            if (menuElement) {
                menuElement.addEventListener('wheel', handleScroll, { passive: true });

                return () => {
                    menuElement.removeEventListener('wheel', handleScroll);
                    if (scrollTimeoutRef.current) {
                        clearTimeout(scrollTimeoutRef.current);
                    }
                };
            }
        };

        // Wait a bit for DOM to be ready
        const timeoutId = setTimeout(addScrollListeners, 50);

        return () => {
            clearTimeout(timeoutId);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, [openReports]);

    const handleReportsClick = (event) => {
        setAnchorElReports(event.currentTarget);
        setAnchorElApps(null); // Close the other menu
    };

    const handleAppsClick = (event) => {
        setAnchorElApps(event.currentTarget);
        setAnchorElReports(null); // Close the other menu
    };

    const handleClose = () => {
        setAnchorElReports(null);
        setAnchorElApps(null);
    };

    const logout = async (e) => {
        e.preventDefault();
        try {
            const response = await instance.post('/logout', {}, { withCredentials: true });
            if (response.status === 200) {
                setAuth({});
            } else {
                alert('Error logging out');
            }
        } catch (error) {
            alert('Error logging out');
        }
    };

    const [q, setQ] = useState("");
    const showSearch = (hierarchicalReports.length > 1) || (navItems.length > 1);
    const inputRef = useRef(null);

    const toggleExpanded = (reportId) => {
        const newExpanded = new Set(expandedReports);
        if (newExpanded.has(reportId)) {
            newExpanded.delete(reportId);
        } else {
            newExpanded.add(reportId);
        }
        setExpandedReports(newExpanded);

        // Update allExpanded state based on whether all parents are expanded
        const allParentIds = getAllParentReportIds(hierarchicalReports);
        const allParentsExpanded = allParentIds.every(id => newExpanded.has(id));
        setAllExpanded(allParentsExpanded);
    };

    const flattenHierarchy = (reports, level = 0) => {
        const flattened = [];
        reports.forEach(report => {
            flattened.push({ ...report, level });
            if (report.children && report.children.length > 0) {
                flattened.push(...flattenHierarchy(report.children, level + 1));
            }
        });
        return flattened;
    };

    const getAllReports = () => {
        return flattenHierarchy(hierarchicalReports);
    };

    const getAllParentReportIds = (reports) => {
        const parentIds = new Set();
        reports.forEach(report => {
            if (report.children && report.children.length > 0) {
                parentIds.add(report.id);
                // Recursively get parent IDs from children
                const childParentIds = getAllParentReportIds(report.children);
                childParentIds.forEach(id => parentIds.add(id));
            }
        });
        return Array.from(parentIds);
    };

    const expandAll = () => {
        const allParentIds = getAllParentReportIds(hierarchicalReports);
        setExpandedReports(new Set(allParentIds));
        setAllExpanded(true);
    };

    const collapseAll = () => {
        setExpandedReports(new Set());
        setAllExpanded(false);
    };

    const toggleExpandAll = () => {
        if (allExpanded) {
            collapseAll();
        } else {
            expandAll();
        }
    };

    // focus search when menu opens (only if shown)
    useEffect(() => {
        if (openReports && showSearch) {
            // delay to ensure menu is mounted
            setTimeout(() => inputRef.current?.focus(), 0);
        }
    }, [openReports, showSearch]);

    const filtered = useMemo(() => {
        // Helper function to check if a report or any of its descendants are favorited
        const hasFavoritedDescendant = (report) => {
            if (favoriteReports.has(report.id)) {
                return true;
            }
            if (report.children && report.children.length > 0) {
                return report.children.some(child => hasFavoritedDescendant(child));
            }
            return false;
        };

        const sortReports = (reports) => {
            return reports.sort((a, b) => {
                const aTopFav = favoriteReports.has(a.id);
                const bTopFav = favoriteReports.has(b.id);
                const aDescFav = !aTopFav && hasFavoritedDescendant(a);
                const bDescFav = !bTopFav && hasFavoritedDescendant(b);

                // Tier 1: top-level favorites first
                if (aTopFav && !bTopFav) return -1;
                if (!aTopFav && bTopFav) return 1;

                // Tier 2: then parents with favorited descendants
                if (aDescFav && !bDescFav) return -1;
                if (!aDescFav && bDescFav) return 1;

                // Tier 3: alphabetical within the same tier
                return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
            });
        };

        if (!showSearch || !q.trim()) {
            const reportsToUse = hierarchicalReports.length > 0 ? hierarchicalReports : navItems;
            return sortReports(reportsToUse);
        }
        const needle = q.toLowerCase();
        if (hierarchicalReports.length > 0) {
            const allReports = getAllReports();
            return sortReports(allReports.filter((i) => i.name.toLowerCase().includes(needle)));
        } else {
            return sortReports(navItems.filter((i) => i.name.toLowerCase().includes(needle)));
        }
    }, [hierarchicalReports, navItems, q, showSearch, favoriteReports]);

    const renderHierarchicalMenuItem = (report, level = 0) => {
        const hasChildren = report.children && report.children.length > 0;
        const isExpanded = expandedReports.has(report.id);
        const isFavorited = favoriteReports.has(report.id);
        // Top-level parents get no left padding, children get indented
        const indentStyle = level > 0 ? { paddingLeft: `${level * 20}px` } : { paddingLeft: '0px' };

        return (
            <div key={report.id}>
                <MenuItem
                    sx={{
                        ...indentStyle,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 16px',
                        ...(isFavorited && {
                            background: isDarkTheme
                                ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%)'
                                : 'linear-gradient(90deg, rgba(255, 165, 0, 0.1) 0%, rgba(255, 165, 0, 0.05) 100%)',
                            borderLeft: `3px solid ${isDarkTheme ? '#FFD700' : '#FFA500'}`,
                            '&:hover': {
                                background: isDarkTheme
                                    ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.08) 100%)'
                                    : 'linear-gradient(90deg, rgba(255, 165, 0, 0.15) 0%, rgba(255, 165, 0, 0.08) 100%)',
                            }
                        })
                    }}
                >
                    <IconButton
                        size="small"
                        aria-label={hasChildren ? (isExpanded ? 'Collapse' : 'Expand') : 'No children'}
                        aria-expanded={hasChildren ? isExpanded : false}
                        onClick={(e) => {
                            if (hasChildren) {
                                e.stopPropagation();
                                toggleExpanded(report.id);
                            }
                        }}
                        sx={{
                            marginRight: '4px',
                            minWidth: '24px',
                            visibility: hasChildren ? 'visible' : 'hidden',
                            pointerEvents: hasChildren ? 'auto' : 'none'
                        }}
                    >
                        {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{
                        mr: '4px',
                        opacity: 0.3,
                        width: '1px'
                    }} />
                    <Box sx={{
                        flex: 1,
                        minWidth: 0,
                        padding: 0,
                        margin: 0,
                        paddingLeft: level > 0 ? `${level * 12}px` : 0,
                        maxWidth: 'calc(100% - 60px)' // Reserve space for star icon
                    }}>
                        <Tooltip
                            key={isScrolling ? 'disabled' : 'enabled'}
                            title={report.name}
                            placement="top"
                            arrow
                            disableHoverListener={isScrolling}
                        >
                            <Link
                                to={`/report/${report.id}`}
                                style={{
                                    ...(isDarkTheme ? linkStyle : lightLinkStyle),
                                    padding: '0.01px 2px',
                                    margin: 0,
                                    display: 'block',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '100%'
                                }}
                                onClick={(e) => {
                                    setQ(""); // clear on close
                                    handleClose();
                                }}
                            >
                                {report.name}
                            </Link>
                        </Tooltip>
                    </Box>
                    {favoritesLoaded && (
                        <StarIcon
                            isFavorited={isFavorited}
                            onToggle={handleToggleFavorite}
                            reportId={report.id}
                            isDarkTheme={isDarkTheme}
                            size={18}
                        />
                    )}
                </MenuItem>
                {hasChildren && (
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        {report.children.map(child => renderHierarchicalMenuItem(child, level + 1))}
                    </Collapse>
                )}
            </div>
        );
    };

    return (
        <div style={divStyle}>
            <Link to="/"><img src={logo} style={logoStyle} alt="Medigap Vision Logo" /></Link>
            <div style={linkContainerStyle}>
                {dashboards.length > 0 && (
                    <Link to="/dashboard" style={isDarkTheme ? adminLinkStyle : lightAdminLinkStyle}>Dashboards</Link>
                )}
                {(hierarchicalReports.length > 0 || navItems.length > 0) && (
                    <IconButton
                        onClick={handleReportsClick}
                        aria-controls="reports-menu"
                        aria-haspopup="true"
                        aria-label="Reports"
                        sx={isDarkTheme ? adminLinkStyle : lightAdminLinkStyle}
                    >
                        Reports
                    </IconButton>
                )}
                {apps.length > 0 && (
                    <IconButton
                        onClick={handleAppsClick}
                        aria-controls="apps-menu"
                        aria-haspopup="true"
                        aria-label="Apps"
                        sx={isDarkTheme ? adminLinkStyle : lightAdminLinkStyle}
                    >
                        Apps
                    </IconButton>
                )}
                {auth.is_admin && (<Link to="/admin" style={isDarkTheme ? adminLinkStyle : lightAdminLinkStyle}>Admin</Link>)}
                <Menu
                    id="reports-menu"
                    anchorEl={anchorElReports}
                    open={openReports}
                    onClose={handleClose}
                    style={menuStyle}
                    slotProps={menuSlotProps}
                >
                    {showSearch && (
                        <Box sx={{ p: 1, position: "sticky", background: "background.paper", top: 0, zIndex: 9999 }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <TextField
                                    inputRef={inputRef}
                                    value={q}
                                    onChange={(e) => setQ(e.target.value)}
                                    onKeyDown={(e) => {
                                        const navKeys = ["Home", "End", "ArrowUp", "ArrowDown", "PageUp", "PageDown"];
                                        if (navKeys.includes(e.key)) {
                                            // when we are using "moving keys" the parent div is being focused
                                            e.stopPropagation();
                                        }
                                    }}
                                    autoFocus
                                    size="small"
                                    placeholder="Search reports..."
                                    inputProps={{ "aria-label": "Search reports" }}
                                    sx={{ flex: 1 }}
                                />
                                {hierarchicalReports.length > 0 && !q.trim() && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={toggleExpandAll}
                                        startIcon={allExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
                                        sx={{
                                            minWidth: '120px',
                                            width: '120px',
                                            px: 1,
                                            fontSize: '0.7rem',
                                            textTransform: 'none',
                                            height: '32px'
                                        }}
                                    >
                                        {allExpanded ? 'Collapse All' : 'Expand All'}
                                    </Button>
                                )}
                            </Box>
                            <Divider sx={{ mt: 1 }} />
                        </Box>
                    )}
                    <Box sx={{ maxHeight: showSearch ? 360 : 400, overflowY: "auto" }}>
                        {filtered.length === 0 ? (
                            <MenuItem disabled>No results</MenuItem>
                        ) : q.trim() ? (
                            // When searching, show flat list
                            filtered.map((item) => {
                                const isFavorited = favoriteReports.has(item.id);
                                return (
                                    <MenuItem
                                        key={item.id}
                                        onClick={() => {
                                            setQ(""); // clear on close
                                            handleClose();
                                        }}
                                        sx={{
                                            ...(isFavorited && {
                                                background: isDarkTheme
                                                    ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%)'
                                                    : 'linear-gradient(90deg, rgba(255, 165, 0, 0.1) 0%, rgba(255, 165, 0, 0.05) 100%)',
                                                borderLeft: `3px solid ${isDarkTheme ? '#FFD700' : '#FFA500'}`,
                                                '&:hover': {
                                                    background: isDarkTheme
                                                        ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.08) 100%)'
                                                        : 'linear-gradient(90deg, rgba(255, 165, 0, 0.15) 0%, rgba(255, 165, 0, 0.08) 100%)',
                                                }
                                            })
                                        }}
                                    >
                                        <ListItemText sx={{ flex: 1, minWidth: 0, maxWidth: 'calc(100% - 60px)' }}>
                                            <Tooltip
                                                key={isScrolling ? 'disabled' : 'enabled'}
                                                title={item.name}
                                                placement="top"
                                                arrow
                                                disableHoverListener={isScrolling}
                                            >
                                                <Link
                                                    to={`/report/${item.id}`}
                                                    style={{
                                                        ...(isDarkTheme ? linkStyle : lightLinkStyle),
                                                        display: 'block',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '100%'
                                                    }}
                                                >
                                                    {item.name}
                                                </Link>
                                            </Tooltip>
                                        </ListItemText>
                                        {favoritesLoaded && (
                                            <StarIcon
                                                isFavorited={isFavorited}
                                                onToggle={handleToggleFavorite}
                                                reportId={item.id}
                                                isDarkTheme={isDarkTheme}
                                                size={18}
                                            />
                                        )}
                                    </MenuItem>
                                );
                            })
                        ) : hierarchicalReports.length > 0 ? (
                            // When not searching and we have hierarchical data, show hierarchical structure
                            filtered.map((report) => renderHierarchicalMenuItem(report))
                        ) : (
                            // Fallback to flat list when no hierarchical data
                            filtered.map((item) => {
                                const isFavorited = favoriteReports.has(item.id);
                                return (
                                    <MenuItem
                                        key={item.id}
                                        onClick={() => {
                                            setQ(""); // clear on close
                                            handleClose();
                                        }}
                                        sx={{
                                            ...(isFavorited && {
                                                background: isDarkTheme
                                                    ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.1) 0%, rgba(255, 215, 0, 0.05) 100%)'
                                                    : 'linear-gradient(90deg, rgba(255, 165, 0, 0.1) 0%, rgba(255, 165, 0, 0.05) 100%)',
                                                borderLeft: `3px solid ${isDarkTheme ? '#FFD700' : '#FFA500'}`,
                                                '&:hover': {
                                                    background: isDarkTheme
                                                        ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 215, 0, 0.08) 100%)'
                                                        : 'linear-gradient(90deg, rgba(255, 165, 0, 0.15) 0%, rgba(255, 165, 0, 0.08) 100%)',
                                                }
                                            })
                                        }}
                                    >
                                        <ListItemText sx={{ flex: 1, minWidth: 0, maxWidth: 'calc(100% - 60px)' }}>
                                            <Tooltip
                                                key={isScrolling ? 'disabled' : 'enabled'}
                                                title={item.name}
                                                placement="top"
                                                arrow
                                                disableHoverListener={isScrolling}
                                            >
                                                <Link
                                                    to={`/report/${item.id}`}
                                                    style={{
                                                        ...(isDarkTheme ? linkStyle : lightLinkStyle),
                                                        display: 'block',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '100%'
                                                    }}
                                                >
                                                    {item.name}
                                                </Link>
                                            </Tooltip>
                                        </ListItemText>
                                        {favoritesLoaded && (
                                            <StarIcon
                                                isFavorited={isFavorited}
                                                onToggle={handleToggleFavorite}
                                                reportId={item.id}
                                                isDarkTheme={isDarkTheme}
                                                size={18}
                                            />
                                        )}
                                    </MenuItem>
                                );
                            })
                        )}
                    </Box>
                </Menu>
                <Menu
                    id="apps-menu"
                    anchorEl={anchorElApps}
                    open={openApps}
                    onClose={handleClose}
                    style={menuStyle}
                >
                    {apps.map((item) => (
                        <MenuItem key={item.id} onClick={handleClose}>
                            <Link to={`/app/${item.id}`} style={isDarkTheme ? linkStyle : lightLinkStyle}>{item.name}</Link>
                        </MenuItem>
                    ))}
                </Menu>
            </div>
            <div style={buttonContainerStyle}>
                <Button
                    onClick={logout}
                    sx={logoutStyle}
                >
                    Logout
                </Button>
                <Button
                    onClick={() => toggleTheme()}
                    sx={logoutStyle}
                >
                    {isDarkTheme ? <LightModeIcon /> : <DarkModeIcon />}
                </Button>
            </div>
        </div>
    )
};

export default Nav;
